import axios from "axios";

const API = axios.create({
    baseURL: process.env.REACT_APP_AUTOMATION_URL,
    headers: {
        'Content-Type': 'application/json',
    }
})

export const automationTokenSet = (token) => {
    API.interceptors.request.use((config) => {
        config.headers.Authorization = token;
        return config;
    });
};

//login
export const masterAutomation = () => API.get('/get-master-automation-list');
export const cronList = () => API.get('/cron-list');
export const cronSet = (body) => API.post('/cron-set', body);
export const runManual = (body) => API.post('/run-manual', body);
export const cronDelete = (automationName) => API.delete(`/cron-delete/${automationName}`);

export const getLog = (processId, automationName) => API.get(`/get-log/${processId}/${automationName}`);
export const getActiveProcess = (automationName) => API.get(`/get-active-process/${automationName}`);
export const getAllProcess = (automationName) => API.get(`/get-process/${automationName}`);
export const loadParams = (body) => API.post(`/params-upsert`, body);




